import { createStore } from "vuex";
import auth from "@/store/auth";
import product from "@/store/product";
import component from "@/store/component";
import componentInstance from "@/store/componentInstance";
import category from "@/store/category";
import blog from "@/store/blog";
import region from "@/store/region";

export default createStore({
  modules: {
    auth,
    product,
    component,
    componentInstance,
    category,
    blog,
    region
  }
});
